import {
  ArrayField,
  BooleanField,
  Datagrid,
  FunctionField,
  TextField,
  useRecordContext,
} from "react-admin";
import { Box, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import RemoveDocumentTypeDialog from "./RemoveDocumentTypeDialog";

const DocumentTypesList = ({ isActive, onEditDocumentType }) => {
  const campaign = useRecordContext();
  if (!campaign) return null;

  return (
    <ArrayField source="documentTypes">
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        empty={<em>Няма зададени документи</em>}
        sx={settings.style.secondaryDatagrid}
      >
        <TextField source="nameBg" label="Наименование" sortable={false} />
        <TextField source="nameEn" label="Наименование (EN)" emptyText="—" sortable={false} />
        <BooleanField source="isRequired" label="Задължително" sortable={false} />
        {!isActive && (
          <FunctionField
            label=""
            render={documentType => (
              <Box sx={{ display: "flex", gap: 0.5 }}>
                <SecuredComponent permission={permissions.canManageDoctoralCampaignDocumentTypes}>
                  <Button
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => onEditDocumentType(documentType)}
                  />
                </SecuredComponent>
                <SecuredComponent permission={permissions.canManageDoctoralCampaignDocumentTypes}>
                  <RemoveDocumentTypeDialog
                    campaignId={campaign.id}
                    documentTypeId={documentType.id}
                  />
                </SecuredComponent>
              </Box>
            )}
          />
        )}
      </Datagrid>
    </ArrayField>
  );
};

export default DocumentTypesList;
